import styled from 'styled-components';

export const NumberedCircleContainer = styled.div`
  position: relative;
`;
